export enum InfantSessionStorageKeys {
    infantCustomerNumber = 'infantCustomerNumber',
    extraFields = 'extraFields',
}